import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FindMarkupByChannelPipe } from './find-markup-by-channel.pipe';
import { ListingMarkupPipe } from './listing-markup.pipe';
import { Markup } from '@app/features/pricing-and-availability';
import { UiModule } from '@app/ui/ui.module';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { PropertyPricingService } from '../../services/property-pricing/property-pricing.service';
import { map } from 'rxjs/operators';
import { ListingMarkupsGroup } from '@app/shared/models/tax';
@Component({
  standalone: true,
  selector: 'sbnb-property-listing-markups',
  templateUrl: './property-listing-markups.component.html',
  styleUrls: ['./property-listing-markups.component.scss'],
  imports: [CommonModule, FormsModule, UiModule, FindMarkupByChannelPipe, ListingMarkupPipe, TranslocoRootModule],
})
export class PropertyListingMarkupsComponent implements OnInit {
  @Input() propertyListings: any[];
  @Input() showDivider = false;

  public markupData$ = this.propertyPricingService.markupData$;
  public saveStatus$ = this.propertyPricingService.priceSaveState$.pipe(map((status) => status[ListingMarkupsGroup]));

  constructor(private readonly propertyPricingService: PropertyPricingService) {}

  ngOnInit(): void {}

  listingMarkupChanged(listing, newValue) {
    const payload: Markup = {
      platform: listing.unified_platform_key,
      markup: newValue.length > 0 ? newValue / 100 : null,
      listing_id: listing.listing_id,
    };
    this.propertyPricingService.saveListingMarkups(payload);
  }
}
